import React from "react";
import { connect } from "react-redux";
import { Main } from "./styled";
import { Menu, Dropdown, Avatar, Icon } from "antd";
import { Link } from "react-router-dom";
import {homepage} from '../../../../model/constants/variableConstant'
const Logo = ({imgUrl, className, width}) => {
  return (

    <Main className={className}>
        <Link to="/">
            {(imgUrl.indexOf('base64') > 1)?
                <img src={imgUrl} width={width}/>:
                <img src={`${homepage}/${imgUrl}`}/>
            }
        </Link>


    </Main>
  )
}


const mapState = (state) => ({
});

export default connect(mapState, ({ }) => ({
}))(Logo);
